import { combineReducers } from "redux";
import aspiranteReducer from "./aspirante/aspiranteDucks";
import menuReducer from "./menu/menuDucks";
import usuarioReducer from "./usuario/usuarioDucks";
import catalogoReducer from "./aspirante/catalogoDucks";
import correoReducer from "./correo/moduloCorreoDucks";
import descripcionPuestoReducer from "./consultavacantes/descripcionpuestoDucks";
import obtenerSistemaReducer from "./consultavacantes/sistemasDucks";
import obtenerEstadoReducer from "./consultavacantes/cestadoDucks";
import consultaVacanteReducer from "./consultavacantes/consultaVacantesDucks";
import reqAcademicoReducer from "./aspirante/reqAcademicoDuck";
import expLaboralReducer from "./aspirante/expLaboralDuck";
import TipoAspiranteProtestoReducer from "./aspirante/TipoAspiranteProtestoDuck";
import expDigitalReducer from "./aspirante/expDigitalDucks";
import postulacionReducer from "./postulaciones/postulacionesDucks";
import acusePostulacionReducer from "./postulaciones/AcuseDucks";
import estatusBloqueoAspirante from "./aspirante/bloquearAspiranteDucks";
import HomeModalReducer from "./home/HomeModalDuck";

export default combineReducers({
  usuarioLogin: usuarioReducer,
  menu: menuReducer,
  aspirante: aspiranteReducer,
  reqAcademico: reqAcademicoReducer,
  expDigital: expDigitalReducer,
  catalogos: catalogoReducer,
  correo: correoReducer,
  descripcionPuesto: descripcionPuestoReducer,
  sistemas: obtenerSistemaReducer,
  cestados: obtenerEstadoReducer,
  consultaVacantes: consultaVacanteReducer,
  expLaboral: expLaboralReducer,
  tipoAspiranteProtestoStore: TipoAspiranteProtestoReducer,
  postulacion: postulacionReducer,
  acusePostulacionStore: acusePostulacionReducer,
  bloqueoEstatus: estatusBloqueoAspirante,
  homeModalStore: HomeModalReducer
});
